<template>
  <div class="cat-learning-element">
    <NavigationBar />
    <div class="learning-element-header">
      <div class="cl-container header-title">{{ domainName }}</div>
    </div>

    <template v-if="busy">
      <LoadingBounce />
    </template>

    <template v-else>
      <div class="learning-element-container">
        <div class="row align-items-top">
          <CatDomainRank />
          <CatElement v-if="learningElement" 
            :learningElement="learningElement" />
          <InfiniteLoading v-if="isLearningElement" @infinite="infiniteHandler" class="w-100">
            <div slot="spinner">
              <LoadingBounce></LoadingBounce>
            </div>
            <span slot="no-results"></span>
            <span slot="no-more"></span>
          </InfiniteLoading>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';

  import CatDomainRank from '../components/CatDomainRank';
  import CatElement from '../components/CatElement';

  export default {
    name: 'cat-learning-element',
    data() {
      return {
        busy: false,
        limit: 20,
        page: 1,
      };
    },

    components: {
      CatDomainRank,
      CatElement,
      InfiniteLoading,
    },

    computed: {
      ...mapGetters({
        learningElement: 'getLearningElement',
        domain: 'getDomain',
        routeParams: 'getRouteParams',
        isParentUser: 'isParentUser',
        selectedChildId: 'getSelectedChildId',
      }),

      domainName() {
        return this.domain && this.domain.name;
      },

      isLearningElement() {
        return this.learningElement && this.learningElement.length >= 10;
      },
    },

    methods: {
      ...mapActions([
        'fetchDomain',
        'fetchLearningElement',
      ]),

      infiniteHandler($state) {
        const filters = {};
        this.page += 1;
        filters.page = this.page;
        filters.per_page = this.limit;
        filters.subject_id = this.selectedSubject;

        if (this.isParentUser) {
          filters.child_id = this.selectedChildId;
        }
        this.fetchLearningElement({ domainId: this.routeParams.domainId, filters })
          .then((data) => {
            if (data.length > 0) {
              $state.loaded();
            } else {
              $state.complete();
            }
          });
      },
    },

    beforeMount() {
      this.$route.meta.title = this.$t('elements.subtitle');
      this.busy = true;
      this.fetchDomain(this.routeParams.domainId)
        .then(() => {
          const filters = {};
          filters.page = this.page;
          filters.per_page = this.limit;

          if (this.isParentUser) {
            filters.child_id = this.selectedChildId;
            return this.fetchLearningElement({ domainId: this.routeParams.domainId, filters });
          }
          return this.fetchLearningElement({ domainId: this.routeParams.domainId, filters });
        })
        .then(() => {
          this.busy = false;
        });
    },

  };
</script>

<style lang="scss" scoped>
  .cat-learning-element {
    .learning-element-header {
      padding: 36px;

      .header-title {
        color: rgba(0, 0, 0, 0.54);
        font-size: 20px;
        font-weight: bold;
      }
    }

    .learning-element-container {
      max-width: 946px;
      margin: 0 auto;
    }
  }

</style>


// WEBPACK FOOTER //
// CatLearningElement.vue?cbbac59c